import React from "react";
import styles from "./ColumnEditFields.module.css";

import { Field, FieldWrapper } from "@progress/kendo-react-form";
import { Checkbox, NumericTextBox, Switch } from "@progress/kendo-react-inputs";
import { Error, Label, Hint } from "@progress/kendo-react-labels";



/*
  TODO: find better name for component (without column)
*/


const NonNegativeNumericInput = fieldRenderProps => {
    const {
      validationMessage,
      visited,
      id,
      valid,
      label,
      ...others
    } = fieldRenderProps;
    return <>
          {label && <Label editorId={id} editorValid={valid} className={"k-form-label"} style={{width: '100%'}}>
              {label}&nbsp;
          </Label>}
          <div className={styles.numericInput} >
              <NumericTextBox 
                {...others} 
                inputStyle={{ width: '35px'}} 
              />
              {visited && validationMessage && <Error>{validationMessage}</Error>}
          </div>
        </>;
  };
  
  
  const numericValidator = (value) => {
  //  console.log("Validator" + value);
    return value !== undefined && !(value >= 0 && value <= 5 && value % 0.5 === 0);
  }
  
  
  const SwitchInput = fieldRenderProps => {
      const {
        validationMessage,
        visited,
        id,
        valid,
        label,
        modified,
        checked,
        ...others
      } = fieldRenderProps;
  
      return <>
              {label && <Label editorId={id} editorValid={valid} className={"k-form-label"} style={{width: '100%'}}>
                  {label}&nbsp;
                </Label>
              }
              <div className={`${styles.switchField} ${modified? styles.changeIndicator : ''}`}>
                  <Switch {...others} />
                  {visited && validationMessage && <Error>{validationMessage}</Error>}
              </div>
          </>;
    };
  
  const FormCheckbox = (fieldRenderProps) => {
      const {
        validationMessage,
        touched,
        id,
        valid,
        disabled,
        hint,
        optional,
        label,
        ...others
      } = fieldRenderProps;
      const showValidationMessage = touched && validationMessage;
      const showHint = !showValidationMessage && hint;
/*
      const fullLabel = (
        <span>
          {label}
          {optional ? <span className={"k-label-optional"}>(Optional)</span> : ""}
        </span>
      );
*/
      const hindId = showHint ? `${id}_hint` : "";
      const errorId = showValidationMessage ? `${id}_error` : "";
      return (
          <div className={`${styles.userCheckbox}`}>
          <Checkbox
            ariaDescribedBy={`${hindId} ${errorId}`}
/*            label={fullLabel} */
            valid={valid}
            id={id}
            disabled={disabled}
            {...others}
          />
          {showHint && <Hint id={hindId}>{hint}</Hint>}
          {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
          </div>
      );
  };

const ColumnEditFields = props => {

    const {
        column,
        removable,
    } = props;


    return <FieldWrapper
              key={`wrapper${column.field}`}
              className={styles.fieldWrapper}
          >

            <div className={styles.fieldsLabel}>
                {column.title}
            </div>
            <div className={styles.inputWrapper}>
              <Field 
                key={column.field}
                name={`fields['${column.field}']`} 
                component={props.inputType !== undefined ? FormCheckbox : column.type === 'boolean' ? SwitchInput : NonNegativeNumericInput} 
  //                    label={column.title} 
                min={column.min}
                max={column.max}
                validator={numericValidator}
              />
            </div>
            {removable && 
              <Field 
                key={`remove_'${column.field}'`}
                name={`removedFields['${column.field}']`} 
                component={FormCheckbox} 
              />
            }
          </FieldWrapper>;

};

export default ColumnEditFields;